import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import {StatusList} from "../statuses";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";

export default function Details(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case {props.case.reference_no} 
                    
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                display: "grid",
                gridTemplateColumns: "16.6% 16.6% 16.6% 16.6% 16.6% 16.6%",
                gridTemplateRows: "1fr 1fr 1fr 1fr",
            }}>
                {new Array(
                    ["Reference Number", props.case.reference_no],
                    ["Policy Number", props.case.policy_number],
                    ["Insurance Company", props.case.insurance_company],
                    ["Assigned Nurse", props.case.completed_by_id? 
                        props.case.completed_by_id:
                        "Not Assigned"
                    ],
                    ["Service Provider", props.case.service_provider],
                    ["Date Received", format(parseISO(props.case.date_received), "yyyy/MM/dd HH:mm")],
                    ["Date Assigned", props.case.date_assigned? 
                        format(parseISO(props.case.date_assigned), "yyyy/MM/dd HH:mm"):
                        "Not Set"
                    ],
                    ["Appointment Date", props.case.appointment_date? 
                        props.case.appointment_date:
                        "Not Set"
                    ],
                    ["Appointment Time", props.case.appointment_time? 
                        props.case.appointment_time:
                        "Not Set"
                    ],
                    ["Appointment Completion Date", 
                        props.case.appointment_completion_date? 
                        format(parseISO(props.case.appointment_completion_date), "yyyy/MM/dd HH:mm"):
                            "Not Set"
                    ],
                    ["Date Completed", props.case.date_completed? 
                        format(parseISO(props.case.date_completed), "yyyy/MM/dd HH:mm"):
                        "Not Set"
                    ],
                    ["Test Type", props.case.test_type],
                    ["Test Details", props.case.test_details],
                    ["Status", props.case.status + " - " + StatusList[props.case.status]],
                    ["Feedback Status", props.case.feedback_status],
                    ["Feedback Message", props.case.feedback_message],                    
                    ["ID Number", props.case.patient_id],
                    ["Patient Date of Birth", props.case.patient_dob],
                    ["First Name", props.case.patient_firstname],
                    ["Last Name", props.case.patient_lastname],
                    ["Phone Number", props.case.patient_phone],
                    ["Address", props.case.patient_add],
                    ["Town", props.case.patient_town],
                    ["Province", props.case.patient_province],
                ).map((prop, index)=>{                 
                    return (
                        <div key={index} className="property">
                            <div className="label">{prop[0]}</div>
                            <span></span>
                            <div className="value">{prop[1]}</div>
                        </div>
                    )
                })}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}